import { render, staticRenderFns } from "./CustomerImportHeader.vue?vue&type=template&id=71c5bf7d&scoped=true"
import script from "./CustomerImportHeader.vue?vue&type=script&lang=js"
export * from "./CustomerImportHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c5bf7d",
  null
  
)

export default component.exports